import axios from '@/plugins/axios';

async function getDepartmentByName(departName) {
  return axios.get('/businessPush/getDepartmentByName', { params: { departName: departName } });
}

async function placeOrder(params) {
  return axios.post('/businessPush/placeOrder', params);
}

async function userBusinessList(params) {
  return axios.get('/businessPush/userBusinessList', {
    params: {
      searchText: params.searchText,
      start: params.start,
      length: params.length
    }
  });
}

async function sysBusinessList(params) {
  return axios.get('/businessPush/sysBusinessList', {
    params: {
      searchText: params.searchText,
      start: params.start,
      length: params.length
    }
  });
}

async function businessConfig(params) {
  return axios.post('/businessPush/businessConfig', {
    businessPushIds: params.businessPushIds,
    pushStatus: params.pushStatus
  });
}

async function checkIsCanReceiveBusiPush(supplierUserId, buyerOrgId) {
  return axios.get('/businessPush/checkIsCanReceiveBusiPush', {
    params: {
      supplierUserId: supplierUserId,
      buyerOrgId: buyerOrgId
    }
  });
}

export {
  getDepartmentByName,
  placeOrder,
  userBusinessList,
  sysBusinessList,
  businessConfig,
  checkIsCanReceiveBusiPush
};
